<template>
  <div id="pretestReport"> <!-- PROBABLY NEED TO UPDATE ALL CLASSES AND IDS TO REFLECT NAME CHANGE FROM TABLE OF CONTENTS -->
    <div id="pretestReportContent" >
      <div id="pretestReportContainer">
        <div id="pretestReportTop">
          <div id="pretestReportText">
            <h1>YOUR PERSONALIZED REPORT</h1>
            <p>Based on your pre-test results, this lists the top sections for you to review.</p>
          </div>
          <div id="buttonDiv">
            <button class="submit" @click="openModal">RETAKE PRE-TEST</button>
            <button class="submit" @click="displayResults">BACK TO RESULTS</button>
            <button class="submit" @click="printPDF">PRINT YOUR REPORT</button>
          </div>
        </div>
      </div>
      <div class="pretestReportQuestionContainer" v-for="(item, index) in modsStarred" :key="'mod-' + index">
        <div class="moduleName">
          {{item.module}} - <span class="sections">{{ item.sections.length > 1 ? 'Sections' : 'Section' }} </span>
          <span v-for="(section, i) in item.sections" :key="'section-' + i" class="sections">
            {{section}}<span v-if="i != item.sections.length - 1">, </span>
          </span>
        </div>
      </div>
      <div class="pretestReportAttestationContainer" v-if="requiresAttestation">
        &nbsp; <!-- Not having this would cause the background of the button to be hiding behind the upper content area if there weren't any questions/sections to review, for some reason --> 
        <div class="attestationButton" :class="{completed: completed}" @click="completed ? () => {} : completeModule(true)">
          <transition name="fade">
            <div class="attestationMessage" v-if="attestationButtonMessage">
              {{ attestationButtonMessage }}
            </div>
          </transition>
          <transition name="fade">
            <div class="attestationMessage" v-if="!attestationButtonMessage">
              <svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40"><path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/></svg>
            </div>
          </transition>
        </div>
      </div>
      <div id="print" style="display: none;">
        <h1>Sections to Review: </h1>
        <div class="pretestReportQuestionContainer" v-for="(item, index) in modsStarred" :key="'review-' + index">
          <h1>
            {{item.module}} - {{ item.sections.length > 1 ? 'Sections' : 'Section' }}
            <span v-for="(section, i) in item.sections" :key="'sReview-' + i">{{section}}<span v-if="i != item.sections.length - 1">, </span></span>
          </h1>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import * as jsPDF from './../../public/vendor/jspdf.min.js'

export default {
  name: 'PretestReport',
  props: {
    
  },
  computed: {
    ...mapGetters([
      'pretestQuestions',
      'pretestAnswers',
      'currentModule',
      'completed',
      'requiresAttestation',
      'hasMobileMentor',
    ]),
    attestationButtonMessage(){
      let theApp = this;
      let message = '';
      if(theApp.completed){
        message = ''
      }else{
        message = 'Complete Module'
      }
      return message;
    },
  },
  methods: {
    ...mapActions([
      'hideResults',
      'displayResults',
      'openModal',
      'completeModule',
    ]),
    printPDF(){
      var doc = new jsPDF();
      var source = document.getElementById('print');

      var elementHandler = {
        '#ignorePDF': () => {
          return true;
        }
      };
      doc.fromHTML(source, 15, 15, {
        'width': 180,
        'elementHandlers': elementHandler
      });

      doc.save('pretest_report.pdf')
    },
  },
  mounted(){
    let theReport = this;

    // set up list of modules to review
    for(var i = 0; i < theReport.pretestAnswers.length; i++){
      if(!theReport.pretestAnswers[i].correct){
        var currentModName = theReport.pretestAnswers[i].module;
        var currentModObjectIndex;
        var found = theReport.modsStarred.some(function(el, index){
          currentModObjectIndex = index;
          return el.module === currentModName;
        })
        if(!found){
          theReport.modsStarred.push({
            module: theReport.pretestAnswers[i].module,
            sections: theReport.pretestAnswers[i].sections
          })
        }else{
          theReport.pretestAnswers[i].sections.forEach(section => {
            if(theReport.modsStarred[currentModObjectIndex].sections.indexOf(section) === -1){
              theReport.modsStarred[currentModObjectIndex].sections.push(section)
            }else{
              // do nothing -- already contains section
            }
          });
        }
      }
    }

    // sort module sections
    theReport.modsStarred.forEach((module, index) => {
      theReport.modsStarred[index].sections.sort()
    })
  },
  data(){
    return {
      modsStarred: [],
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#pretestReportImage{
  width: 20%;
  height: 100%;
  float: left;
  background-image: url('../assets/img/mentor_TOC.jpg');
  background-repeat: no-repeat;
  background-position: center;
}

#pretestReportTop{
  width: 100%;
  float: left;
  padding: 1%;
  box-sizing: border-box;
  margin-bottom: 50px;
  background-image: url('../assets/img/Quiz_bg.jpg');
  background-repeat: no-repeat;
  background-size: cover;
  border-bottom: 15px solid rgba(0,0,0,0.2);
}
#pretestReportText {
  width: 50%;
  float: left;
  font-size: 20px;
  font-weight: bold;
  padding-left: 25px;
  box-sizing: border-box;
  color: #1b4f6a;

}
#buttonDiv{
  width: 50%;
  float: left;
  margin-top: 25px;
}
#retakePretest{
  color: #055272;
}
#pretestReport{
  position: relative;
  display: block;
  width: 80%;
  max-width: 1024px;
  height: calc(100% - 50px);
  margin: 0 auto;
  background-color: white;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  overflow-x: hidden;
  z-index: 4;
  top: 50px;
  background-image: url(../assets/img/Main_bg.jpg);
  background-repeat: no-repeat;
  background-size: cover;
}
#pretestReportContent{
  position: relative;
  display: block;
  width: 100%;
  float: right;
}

.pretestReportQuestionContainer{
  height: auto;
  border-bottom: 1px solid #f3f4f4;
}

.pretestReportQuestion{
  width: 100%;
  min-height: 30px;
  margin-bottom: 10px;
  margin-left: 55px;
  float: left;
  background-color: #ffffff;
}

.moduleName{
  color: #ffffff;
  font-family: MontserratBold;
  text-transform: uppercase;
  padding: 10px 25px;
  font-size: 20px;
}

.sections{
  color: #c0c3c6;
}

@media(max-width: 760px){
  #pretestReport{
    width: 100%;
  }
  #pretestReportContent{
    width: 100%;
  }
  #pretestReportText{
    width: 100%;
  }
  #buttonDiv{
    width: 100%;
    margin-top: 5px;
    margin-bottom: 25px;
  } 
}
</style>
